module.exports = __webpack_public_path__ + "media/images/lounge_icon@3x-bda4413b.png";